import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import { subscribeChannelRequested, unsubscribeChannel } from './channels.actions';
import { ChannelType } from './channels.models';
import { getChannels, getSponsoredChannels, getSubscribedChannels } from './channels.selectors';

@Injectable()
export class NewsfeedChannelsFacade {
  allChannels$ = this.store.pipe(select(getChannels));
  sponsoredChannels$ = this.store.pipe(select(getSponsoredChannels));
  subscribedChannels$ = this.store.pipe(select(getSubscribedChannels));

  constructor(private readonly store: Store) {}

  subscribe(fairId: string, id: string, context: string, channelType: ChannelType = 'EXHIBITOR'): void {
    this.store.dispatch(subscribeChannelRequested({ fairId, channelType, id, context }));
  }

  unsubscribe(fairId: string, id: string, context: string, channelType: ChannelType = 'EXHIBITOR'): void {
    this.store.dispatch(unsubscribeChannel({ fairId, channelType, id, context }));
  }
}
